export class CdRdListHelper {

    static RdListFileName = "Лист РД.pdf";
    static RdListFileID = "E21E685D-EB85-4730-BE6B-918EA7EDC2BE";

  }